import { createSelector } from 'reselect';
import { armstrongV1Selector } from '@xingternal/platform-layout-selectors';
const settingsDropdownListSelector = createSelector(armstrongV1Selector, (armstrongV1) => ({ armstrongV1 }));
export { settingsDropdownListSelector };
//# sourceMappingURL=SettingsDropdownList.selectors.js.map